import { Icon } from '@eventbrite/legacy-eds.icon';
import { MagnifyingGlassChunky } from '@eventbrite/legacy-eds.iconography';
import { InputField } from '@eventbrite/legacy-eds.input-field';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import { ArrowLeftIcon } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React, { SyntheticEvent } from 'react';
import { useEffectOnce } from 'react-use';
import { useSearchInputContext } from '../../context';
import { useRunSearch } from '../../hooks';
import styles from './SearchInput.module.scss';

type Props = {
    dropdownVisible?: boolean;
    handleSearchClick?: (e: React.MouseEvent<HTMLElement>) => void;
    handleBackButtonClick?: (e: React.MouseEvent<HTMLElement>) => void;
    variant?: 'takeover' | 'header';
};

const placeHolderTextQuery = gettext('Search events');

//TODO: Create shared base "inputfield" component to share between location and search
export const SearchInput: React.FunctionComponent<Props> = ({
    dropdownVisible = false,
    handleSearchClick = () => 0,
    handleBackButtonClick = () => 0,
    variant = 'takeover',
}) => {
    const { query, setQuery } = useSearchInputContext();
    const handleRunSearch = useRunSearch();

    const className = classNames(styles[`searchInput--${variant}`]);

    useEffectOnce(() => {
        if (typeof window !== 'undefined') {
            const serverData = (window as any)?.__SERVER_DATA__;
            const eventSearch = serverData?.search_data?.event_search;
            const previousQuery = eventSearch?.q;

            if (setQuery !== undefined && previousQuery !== undefined) {
                setQuery(previousQuery);
            }
        }
    });

    const handleSubmit = (e: SyntheticEvent) => {
        e.preventDefault();

        handleRunSearch({
            search: { q: query },
            analytics: { action: 'RunSearch', label: query },
        });
    };

    const prefix =
        variant === 'header' && dropdownVisible ? (
            <button
                className={styles.prefixBackButton}
                type="button"
                onClick={handleBackButtonClick}
            >
                <ArrowLeftIcon />
            </button>
        ) : (
            <Icon type={<MagnifyingGlassChunky />} />
        );

    return (
        <form className={className} onSubmit={(e) => handleSubmit(e)}>
            <InputField
                autoComplete="off"
                id="search-autocomplete-input"
                label={gettext('Search events')}
                style="basic"
                name="search-autocomplete-input"
                value={query}
                onChange={setQuery}
                onClick={handleSearchClick}
                placeholder={placeHolderTextQuery}
                borderType="hidden"
                bottomSpacing={0}
                type="search"
                enterkeyhint="search"
                prefix={prefix}
                role=""
            />
        </form>
    );
};
